import React from "react"
import { Link } from "gatsby"
import styled from "styled-components"


const Footer = () => (
  <StyledFooter>
    <Wrap>
        <FooterNav>
            <div>
              <Header>Read</Header>
              <MenuPages>
                <li><span>★ </span><Link to="/red-square/">Red Square</Link></li>
                <li><span>★ </span><Link to="/moscow-city/">Moskva City</Link></li>
                <li><span>★ </span><Link to="/new-arbat/">New Arbat</Link></li>
                <li><span>★ </span><Link to="/grand-kremlin-palace/">Grand Kremlin Palace</Link></li>
                <li><span>★ </span><Link to="/russian-souvenirs/">Top Russian Souvenirs</Link></li>
                <li><Link to="/best-ways-to-meet-moscow-girls/">Best Ways to Meet Moscow Girls</Link></li>
                <li><Link to="/moscow-night-clubs-that-you-probably-wont-get-into/">Moscow Face Control</Link></li>
                <li><Link to="/krasny-oktyabr-is-dead/">Krasny Oktyabr: The Party is Over</Link></li>    
                <li><Link to="/dachas-russia/">What is Russian Dacha?</Link></li>
                <li><Link to="/mavrin-models/">Mavrin Models 2019</Link></li>
                <li><Link to="/filip-kirkorov/">Who is Filip Kirkorov?</Link></li>
              </MenuPages>
            </div>
            <div>
            <Header>Navigate</Header>
              <MenuPages>
                <li><Link to="/attractions/">Attractions</Link></li>
                <li><Link to="/hotels/">Top Hotels</Link></li>
                <li><Link to="/best-restaurants-moscow/">Best Dining</Link></li>
                <li><Link to="/moscow-nightclubs/">Night Clubs</Link></li>
                <li><Link to="/moscow-strip-clubs/">Strip Clubs</Link></li>
                <li><Link to="/moscow-erotic-massage/">Erotic Massage</Link></li>
              </MenuPages>
            </div>
            {/* <div>
            <Header>Partners</Header>
              <MenuPages>
                <li><a href="http://followmckinsey.com" target="_blank">FollowMckinsey.com</a></li>
              </MenuPages>
            </div> */}
            <div>
            <ContactHeader><Link to="/contacts/">Contact Us</Link></ContactHeader>
            </div>
        </FooterNav>

        <CopyRight>
          © {new Date().getFullYear()}
          {` `}
          <Link to="/">
            Trendy Moscow
          </Link>
          <Statement>Moscow Survival Guide - <Link to="/">Trendymoscow.com</Link></Statement>
          </CopyRight>
    </Wrap>
  </StyledFooter>
)

const StyledFooter = styled.footer`
  max-width: 100%;
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  background: #000;
  padding: 5px 10px 20px;
  color: white;
  ul li {
    font-family: 'Roboto', sans-serif;
    font-weight: 400;
    list-style: none;
  }
  h2 {
    color: #fff;
  }
`
const Wrap = styled.div`

  a {
    color: white;
  }
`
const CopyRight = styled.div`
  font-weight: 400;
  max-width: 410px;
  margin: 0 auto;
  text-align: center;
  line-height: 1.2;
  padding: 2rem 0;
  @media only screen and (max-width: 390px) {
      margin-top: 5px;
    }
`

const MenuPages = styled.ul`
    margin: 0;
    padding: 0;
    span {
      color: #FF0000;
    }
`

const Statement = styled.div`

`
const Header = styled.h2`
  border-bottom: 2px solid #fff;
`
const ContactHeader = styled.h2`
  border-bottom: 2px solid #FF0000;
`

const FooterNav = styled.div`
  display: flex;
  padding: 2rem 0 4rem;
  justify-content: space-between;
  max-width: 900px;
  margin: 0 auto;
  @media (max-width: 940px) {
    flex-direction: column;
  }
`

export default Footer
